import React from 'react';
import { Breadcrumbs, Typography } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootReducer } from '@store/index';
import { getRoutesByProfile } from '@utils/Routes';
import { ProfileTypes } from '@api/Users/User';
const CustomBreadcrumbs = () => {
    const { profileSelected } = useSelector((state: RootReducer) => state.auth);
    const location = useLocation();
    const navigation = useNavigate();

    const pathNames = location.pathname.split('/').filter((x) => x);

    pathNames.forEach((path, index) => {
        if (index > 0) {
            pathNames[index] = `${pathNames[index - 1]}/${path}`;
        }
    });
    const getRouteByPath = (path: string, profile: ProfileTypes) => {
        const currentPath = path.replace(`${profile}/`, '');
        const routes = getRoutesByProfile(profile);
        const route = routes.find((r) => r.path === currentPath);
        if (route) {
            return route;
        }
        return routes[0];
    };

    const isCurrentPath = (path: string) => {
        const current = location.pathname;
        return current === `/${path}`;
    };

    const onGoBack = (path: string) => {
        const current = location.pathname.split('/');
        const times = `/${path}`.split('/');
        const back = current.length - times.length;
        if (back > 0) {
            navigation(-back);
        }
    };

    return (
        <Breadcrumbs aria-label="Breadcrumb" color="white">
            {profileSelected &&
                pathNames.map((path, index) => {
                    if (path !== profileSelected) {
                        return (
                            <Typography
                                key={index}
                                variant="h6"
                                sx={{ cursor: !isCurrentPath(path) ? 'pointer' : 'normal' }}
                                fontWeight={isCurrentPath(path) ? 600 : 400}
                                onClick={() => onGoBack(path)}
                            >
                                {getRouteByPath(path, profileSelected).name}
                            </Typography>
                        );
                    }
                })}
        </Breadcrumbs>
    );
};
export default CustomBreadcrumbs;
